<template>
  <div>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>原始内容</span>
            </div>
            <el-row :gutter="20">
              <el-form ref="form" :model="textForm" label-width="100px" size="mini">
                <el-form-item label="">
                  <el-input
                      type="textarea"
                      :rows="20"
                      placeholder="原始内容"
                      v-model="textForm.text1">
                  </el-input>
                </el-form-item>
                <el-form-item size="large" align="center">
                  <el-button type="primary"
                             style="margin-left: 20px;background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"
                             @click="onSubmitEnc">加密
                  </el-button>
                </el-form-item>
              </el-form>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header-red"></i>
              <span>加密后的内容</span>
            </div>
            <el-row :gutter="20">
              <el-form ref="form" :model="textForm" label-width="100px" size="mini">
                <el-form-item label="">
                  <el-input
                      type="textarea"
                      :rows="20"
                      placeholder="加密后内容"
                      v-model="textForm.text2">
                  </el-input>
                </el-form-item>
                <el-form-item size="large" align="center">
                  <el-button type="primary"
                             style="margin-left: 20px;background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"
                             @click="onSubmitEncDec">解密
                  </el-button>
                </el-form-item>
              </el-form>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>


  </div>

</template>

<script>
export default {
  name: "DataEncrypt",
  data() {
    return {
      textForm: {
        text1: "患者女性，44岁绝经，身高168cm，体重70Kg。多个椎体压缩性骨折史，行骨密度(BMD)检查，本中心的设备是HOLOGIC discovery A，本次测量技术质量符合要求，结果报告如下：\n" +
            "\n" +
            "部位              骨密度(g/cm2)        T值        Z值       \n" +
            "\n" +
            "腰椎(L2-4)　　　　0.671　　　　　　　　-3.7　　　  -1.2\n" +
            "\n" +
            "股骨颈　　　　　　0.660　　　　　　　　-1.7　　　  0.4　\n" +
            "　　\n" +
            "全髋　　　　　　　0.704　　　　　　　　-1.9　　　  -0.2",
        text2: '',
      },
    };
  },
  mounted() {
    this.onSubmitEnc()
  },
  methods: {
    onSubmitEnc() {
      this.textForm.text2 = ''
      this.$http.post(process.env.VUE_APP_API_HOST + "/service_encrypt_enc", this.textForm, {"content-type": "application/json"}).then((res) => {
        this.textForm.text2 = res.data.text2;
      })
    },
    onSubmitEncDec() {
      this.textForm.text1 = ''
      this.$http.post(process.env.VUE_APP_API_HOST + "/service_encrypt_dec", this.textForm, {"content-type": "application/json"}).then((res) => {
        this.textForm.text1 = res.data.text1;
      })
    },
  },


}
</script>

<style scoped>
.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
</style>
